// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + "code-example-vendor" + "." + "16af1611" + ".chunk.js");